import React, { useContext, useState } from 'react'
import Affiliations from './Affiliations'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getAffiliationsFetch } from 'store/middlewares/affiliation.crud'
import { initialPage, initialPageSize } from 'keys/pagination'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { AbilityContext } from 'components/Permissions/Can'
import { useSelector } from 'react-redux'
import { affiliationsHooks } from '.'
import qc from 'keys/queryClient'

const AffiliationPage = () => {
    const [page, setPage] = useState(initialPage)
    const [rowOpen, setRowOpen] = useState(null)
    const [gradeOpen, setGradeOpen] = useState(null)
    const [pageSize, setPageSize] = useState(initialPageSize)
    const [sorting, setSorting] = useState([])
    const [searchVal, setSearchVal] = useState("")
    const [classIndexTab, setClassIndexTab] = useState(0)
    const [groupTab, setGroupTab] = useState(0)

    const { groups } = useSelector(state => state.affiliation)

    const groupTabByName = affiliationsHooks.useAffiliationGroupItems()
    const affiliationGroups = groups?.filter(group => groupTabByName?.[group.name])

    const ability = useContext(AbilityContext)
    const navigate = useNavigate()
    const isSuperuser = ability.can('manage', 'super-user')

    const affiliationsOptions = queryOptions({
        queryKey: [qc.affiliationData, groupTab, page, pageSize, sorting, searchVal],
        queryFn: async () => {
            const { data } = await getAffiliationsFetch({ page, pageSize, sorting, search: searchVal, group: affiliationGroups?.[groupTab]?.id })

            if (!isSuperuser && data.count == 1) {
                const affiliationId = data.results[0].id
                navigate(`${app.affiliations}/${affiliationId}`)
            }

            return data
        }
    })

    const affiliations = useQuery(affiliationsOptions)

    const commonValue = {
        affiliations,
        affiliationsOptions,
        page, setPage,
        pageSize, setPageSize,
        sorting, setSorting,
        searchVal, setSearchVal,
        rowOpen, setRowOpen,
        gradeOpen, setGradeOpen,
        classIndexTab, setClassIndexTab,
        groupTab, setGroupTab,
        affiliationGroups
    }

    return (
        <AffiliationsContext.Provider value={commonValue}>
            <Affiliations />
        </AffiliationsContext.Provider>
    )
}

export const AffiliationsContext = React.createContext()
export default AffiliationPage